import { IMessageBroker } from "@sparkware/uc-sdk-core";
import { MB_HEADERS } from "../externalCommunication";

export function publishLoginIntent(messageBroker: IMessageBroker) {
  messageBroker.navigation.topics.performAction.publish(MB_HEADERS, {
    actionID: "loginIntent",
  });
}
